var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "big-data"
  }, [_c("section", {
    staticClass: "big-data__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "大数据",
      description: "同花顺大数据产品是基于AARRR 用户生命周期管理模型，为互联网经营者提供数据分析及精细运营支持的工具，\n      它集账户分析、账户诊断、行为分析、标签系统、智能推荐、标签云等功能于一体，助力企业经营更科学、更智能。",
      productId: _vm.productId
    }
  })], 1), _c("section", {
    staticClass: "big-data__features-wrapper"
  }, [_c("Features", {
    attrs: {
      featuresList: _vm.featuresList
    }
  })], 1), _c("section", {
    staticClass: "big-data__function-wrapper"
  }, [_c("Function")], 1), _c("section", {
    staticClass: "big-data__appointment-wrapper"
  }, [_c("Appointment2", {
    staticClass: "stock-appoint",
    attrs: {
      productId: _vm.productId
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };